import PropTypes from 'prop-types';
import {Helmet} from 'react-helmet';
import Typography from '@material-ui/core/Typography';
import {Row, Col} from 'react-grid-system';
import TeamList from 'Admin/Presentation/TeamList';
import AclList from 'Admin/Presentation/AclList';
import SelectSbsUser from 'Components/SelectSbsUser';

function AdminPermission(props) {
  const {selectedUser, onSelectUser, aces, onChangeAce, teams, onSelectTeam} =
    props;

  return (
    <div>
      <Helmet title="Permissions" defer={false} />
      <Typography
        color="textSecondary"
        variant="h6"
        style={{padding: 15, background: 'lightgrey'}}
      >
        modify: User Permissions
      </Typography>
      <Col sm={4}>
        <SelectSbsUser
          fullWidth
          useUsername
          value={selectedUser}
          onChange={onSelectUser}
          style={{padding: 20}}
        />
      </Col>
      {selectedUser && (
        <Row style={{height: 25}}>
          <Col xs={12} sm={9}>
            <AclList aces={aces} onChangeAce={onChangeAce} />
          </Col>
          <Col xs={12} sm={3}>
            <TeamList teams={teams} onSelectTeam={onSelectTeam} />
          </Col>
        </Row>
      )}
    </div>
  );
}

AdminPermission.propTypes = {
  teams: PropTypes.array.isRequired,
  aces: PropTypes.array.isRequired,
  selectedUser: PropTypes.shape({
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    username: PropTypes.string,
  }),
  onSelectUser: PropTypes.func.isRequired,
  onChangeAce: PropTypes.func.isRequired,
  onSelectTeam: PropTypes.func.isRequired,
};

AdminPermission.defaultProps = {
  selectedUser: null,
};

export default AdminPermission;
